import { forwardRef, PropsWithChildren } from 'react';

import { Label } from '../Label/Label';
import { Content, StyledInput, Text } from './CheckboxField.styles';
import type { CheckboxFieldProps } from './CheckboxField.types';

export const CheckboxField = forwardRef<
  HTMLDivElement,
  PropsWithChildren<CheckboxFieldProps>
>(({ children, htmlId, label, className, ...inputRest }, ref) => {
  return (
    <div ref={ref} className={className}>
      <Label htmlId={htmlId + '_label'} label={label} />

      <Content>
        <StyledInput id={htmlId} type="checkbox" {...inputRest} />

        <Text htmlFor={htmlId}>{children}</Text>
      </Content>
    </div>
  );
});

CheckboxField.displayName = 'CheckboxField';
